import type {ReactElement} from 'react';
import React from 'react';
import {Button, Size, Type} from '@Components/button';
import styles from './chat-controls.module.scss';

interface ChatControlsProps {
  chatId: string | undefined;
  isStreaming: boolean;
  onStop: () => Promise<void>;
}

export function ChatControls({chatId, isStreaming, onStop}: ChatControlsProps): ReactElement | null {
  const isStopDisabled = !isStreaming;

  if (!chatId) {
    return null;
  }

  return (
    <Button
      customClasses={`spacing-m-b-2 spacing-m-t-2 ${styles.container}`}
      type={isStopDisabled ? Type.SECONDARY : Type.PRIMARY}
      size={Size.XSMALL}
      isFullWidth={false}
      text={'Stop'}
      onClick={onStop}
      disabled={isStopDisabled}
    />
  );
}
